// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  haulId: __t.u64().primaryKey().name("haul_id"),
  portId: __t.u64().name("port_id"),
  termsVersion: __t.u32().name("terms_version"),
  captain: __t.identity(),
  splitJson: __t.string().name("split_json"),
  splitRev: __t.u32().name("split_rev"),
  relayPartner: __t.identity().name("relay_partner"),
  custodianRev: __t.u32().name("custodian_rev"),
  relayFrom: __t.identity().name("relay_from"),
  relayFromShip: __t.u64().name("relay_from_ship"),
  relayAt: __t.timestamp().name("relay_at"),
  offerTo: __t.identity().name("offer_to"),
  offerBps: __t.u32().name("offer_bps"),
  offerExpiresAt: __t.timestamp().name("offer_expires_at"),
  beginBy: __t.identity().name("begin_by"),
  beginAt: __t.timestamp().name("begin_at"),
  beginJson: __t.string().name("begin_json"),
  acceptedAt: __t.timestamp().name("accepted_at"),
  updatedAt: __t.timestamp().name("updated_at"),
});
